module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2e"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "lov"
    }
  }), _c('strong', [_vm._v("LOVE LETTER TO READERS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dear Reader,")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Just when you think you’ve read every book and heard every conceivable sound byte about out-of-control behaviors, addictions and compulsions, out comes a message and a simple daily process so exhilarating it takes your breath away. You’ve been seeking a new solution, and this is it. There are no coincidences.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("The Power to Stop")]), _vm._v(" is organized and presented in a way that releases you from fears about your out-of-control behavior or your inability to stop yourself. The total absence of fear-based ideas will present a radically different message for most people. We live in a fear-based world where fear is erroneously perceived as correct, useful and godly. Since I do not extend any ideas that engender fear, it’s not reasonable to expect the same old message about stopping that you’ve heard a thousand times before.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The process of learning how to stop yourself is also the deeply calming practice of learning how to love yourself. This uncompromising love-based solution makes "), _c('em', [_vm._v("The Power to Stop")]), _vm._v(" a miracle in action. Miracles are possible because the Holy Spirit is present whenever love is extended and received, especially love of self. You are worthy of a healing miracle. You are worthy of self-love and the love of others. You are worthy of goodness. You are worthy of having the life and bodily experience that you envision for yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("The Power to Stop")]), _vm._v(" is the uplifting message that I personally most wanted to hear, but could not find anywhere else except inside myself. It’s with great joy and humble service to the world that I share this song in my heart that "), _c('em', [_vm._v("must")]), _vm._v(" be sung.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Love is the only thing that really matters,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Karen Bentley")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cdbca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/readers.vue
// module id = 81
// module chunks = 0